"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatComparisonTextForDetail = exports.formatComparisonTextForCard = void 0;
var status_1 = require("../features/status");
var getters_1 = require("../features/threshold/getters");
var models_1 = require("../features/threshold/models");
var localization_1 = require("../localization");
var numberFormatter_1 = require("./numberFormatter");
var symbolForDelta_1 = require("./symbolForDelta");
var formatComparisonTextForCard = function (comparison, definition, formatString, status) {
    var style = (0, getters_1.getLineStyleForDefaultThresholdLine)(definition);
    switch (style === null || style === void 0 ? void 0 : style.deltaLabel) {
        case models_1.DeltaLabelStyle.TARGET_VALUE:
            return formatTargetDeltaTextForCard(comparison, formatString, status);
        case models_1.DeltaLabelStyle.HISTORICAL_DELTA:
        case undefined:
        default:
            return formatDeltaTextForCard(comparison);
    }
};
exports.formatComparisonTextForCard = formatComparisonTextForCard;
var formatTargetDeltaTextForCard = function (comparison, formatString, status) {
    var iconAccessibilityText = getAccessibilityTextForStatusIcon(status !== null && status !== void 0 ? status : status_1.ThresholdStatus.UNKNOWN);
    var accessibilityTextPrefix = iconAccessibilityText + (iconAccessibilityText !== '' ? ' ' : '');
    if (comparison.absolute === 0) {
        return {
            text: localization_1.Messages.metricsComparisonAtTarget(),
            comparisonText: localization_1.Messages.metricsComparisonAtTarget(),
            accessibilityText: accessibilityTextPrefix + localization_1.Messages.metricsComparisonAtTarget(),
        };
    }
    var formattedValue = (0, numberFormatter_1.formatAbsoluteValue)(comparison.absolute, formatString);
    var targetText = comparison.absolute < 0
        ? localization_1.Messages.metricsComparisonBelowTarget({ value: formattedValue })
        : localization_1.Messages.metricsComparisonAboveTarget({ value: formattedValue });
    return {
        text: targetText,
        comparisonText: targetText,
        accessibilityText: accessibilityTextPrefix + targetText,
    };
};
var formatDeltaTextForCard = function (comparison) {
    if (comparison.absolute === 0) {
        return {
            text: localization_1.Messages.metricsComparisonNoChange(),
            comparisonText: localization_1.Messages.metricsComparisonNoChange(),
            accessibilityText: localization_1.Messages.metricsComparisonNoChange(),
        };
    }
    var symbol = (0, symbolForDelta_1.symbolForDelta)(comparison);
    var text = (0, numberFormatter_1.formatValueAsUnsignedPercentage)(comparison.percentage);
    var direction = symbol !== '' ? (comparison.absolute >= 0 ? '+' : '-') : '';
    return {
        symbol: symbol,
        text: text,
        comparisonText: symbol + text,
        accessibilityText: direction + text,
    };
};
var formatComparisonTextForDetail = function (comparison, definition, formatString, status) {
    var style = (0, getters_1.getLineStyleForDefaultThresholdLine)(definition);
    switch (style === null || style === void 0 ? void 0 : style.deltaLabel) {
        case models_1.DeltaLabelStyle.TARGET_VALUE:
            return formatTargetDeltaText(comparison, formatString, status);
        case models_1.DeltaLabelStyle.HISTORICAL_DELTA:
        case undefined:
        default:
            return formatDeltaText(comparison, formatString);
    }
};
exports.formatComparisonTextForDetail = formatComparisonTextForDetail;
var formatTargetDeltaText = function (comparison, formatString, status) {
    var iconAccessibilityText = getAccessibilityTextForStatusIcon(status !== null && status !== void 0 ? status : status_1.ThresholdStatus.UNKNOWN);
    var accessibilityTextPrefix = iconAccessibilityText + (iconAccessibilityText !== '' ? ' ' : '');
    if (comparison.absolute === 0) {
        return {
            text: localization_1.Messages.metricsComparisonAtTarget(),
            comparisonText: localization_1.Messages.metricsComparisonAtTarget(),
            accessibilityText: accessibilityTextPrefix + localization_1.Messages.metricsComparisonAtTarget(),
        };
    }
    var formattedValue = (0, numberFormatter_1.formatAbsoluteValue)(comparison.absolute, formatString);
    var targetText = comparison.absolute < 0
        ? localization_1.Messages.metricsComparisonBelowTargetDetail({ value: formattedValue })
        : localization_1.Messages.metricsComparisonAboveTargetDetail({ value: formattedValue });
    return {
        text: targetText,
        comparisonText: targetText,
        accessibilityText: accessibilityTextPrefix + targetText,
    };
};
var formatDeltaText = function (comparison, formatString) {
    if (comparison.absolute === 0) {
        return {
            text: localization_1.Messages.metricsComparisonNoChange(),
            comparisonText: localization_1.Messages.metricsComparisonNoChange(),
            accessibilityText: localization_1.Messages.metricsComparisonNoChange(),
        };
    }
    var symbol = (0, symbolForDelta_1.symbolForDelta)(comparison);
    var text = formatDeltaValues(comparison, formatString);
    var direction = symbol !== '' ? (comparison.absolute >= 0 ? '+' : '-') : '';
    return {
        symbol: symbol,
        text: text,
        comparisonText: symbol + text,
        accessibilityText: direction + text,
    };
};
var formatDeltaValues = function (comparison, formatString) {
    // Since the comparison widget shows up/down arrows, we format them without a sign.
    var percentage = (0, numberFormatter_1.formatValueAsUnsignedPercentage)(comparison.percentage);
    var absolute = (0, numberFormatter_1.formatAbsoluteValue)(comparison.absolute, formatString || '');
    return "".concat(percentage, " (").concat(absolute, ")");
};
var getAccessibilityTextForStatusIcon = function (status) {
    switch (status) {
        case status_1.ThresholdStatus.GOOD:
            return localization_1.Messages.metricsGoodStatusDescription();
        case status_1.ThresholdStatus.BAD:
            return localization_1.Messages.metricsBadStatusDescription();
        case status_1.ThresholdStatus.NEUTRAL:
            return localization_1.Messages.metricsNeutralStatusDescription();
        case status_1.ThresholdStatus.UNKNOWN:
        default:
            return '';
    }
};
//# sourceMappingURL=deltaFormatter.js.map